import React, {
    useEffect,
    useState
} from "react";

import {
    ArrowLeftOutlined,
    CompressOutlined,
    ExpandOutlined,
    ReloadOutlined
} from "@ant-design/icons";

import {
    useNavigate
} from "react-router-dom";

import axiosInstance
    from "../utils/axios";


export default function InternalPdfView({
    slug,
    title
}) {

    const navigate =
        useNavigate();

    const [pdfUrl, setPdfUrl] =
        useState("");

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");

    const [reloadKey, setReloadKey] =
        useState(0);

    const [fullscreen, setFullscreen] =
        useState(false);


    useEffect(() => {

        let alive = true;

        const load = async () => {

            try {

                setLoading(true);
                setError("");
                setPdfUrl("");

                /*
                 * Chi xin mot ticket nho.
                 * PDF KHONG duoc tai thanh blob nua.
                 */
                const response =
                    await axiosInstance.get(
                        `/my-book/pdf-ticket/${encodeURIComponent(
                            slug
                        )}`
                    );

                const relativeUrl =
                    response?.data
                        ?.data
                        ?.url;

                if (!relativeUrl) {
                    throw new Error(
                        "Không tạo được phiên đọc PDF."
                    );
                }

                if (!alive) {
                    return;
                }

                const baseURL =
                    String(
                        axiosInstance
                            ?.defaults
                            ?.baseURL ||
                        ""
                    ).replace(
                        /\/$/,
                        ""
                    );

                const streamUrl =
                    /^https?:\/\//i.test(
                        relativeUrl
                    )
                        ? relativeUrl
                        : (
                            baseURL +
                            (
                                relativeUrl.startsWith(
                                    "/"
                                )
                                    ? relativeUrl
                                    : "/" +
                                        relativeUrl
                            )
                        );

                setPdfUrl(
                    streamUrl
                );

            } catch (err) {

                console.error(
                    "INTERNAL PDF STREAM ERROR:",
                    err
                );

                if (alive) {
                    setLoading(false);
                    setError(
                        err?.response
                            ?.data
                            ?.message ||
                        err?.message ||
                        "Không thể mở tài liệu PDF."
                    );
                }

            } finally {

                /*
                 * Khong tat loading o day.
                 * Cho den khi iframe PDF thuc su load xong
                 * thi moi tat loading bang onLoad.
                 */
            }
        };

        load();

        return () => {
            alive = false;
        };

    }, [
        slug,
        reloadKey
    ]);



    useEffect(() => {
        if (!loading || !pdfUrl || error) return;

        const timeout = window.setTimeout(() => {
            setLoading(false);
            setError(
                "Tài liệu tải quá lâu. Vui lòng thử lại. " +
                "Nếu vẫn không mở được, hãy thử Chrome hoặc Edge phiên bản mới."
            );
        }, 45000);

        return () => window.clearTimeout(timeout);
    }, [loading, pdfUrl, error]);

    useEffect(() => {

        const change =
            () =>
                setFullscreen(
                    Boolean(
                        document.fullscreenElement
                    )
                );

        document.addEventListener(
            "fullscreenchange",
            change
        );

        return () =>
            document.removeEventListener(
                "fullscreenchange",
                change
            );

    }, []);


    const toggleFullscreen =
        async () => {

            try {

                if (
                    document.fullscreenElement
                ) {
                    await document
                        .exitFullscreen();

                    return;
                }

                await document
                    .documentElement
                    .requestFullscreen?.();

            } catch (error) {

                console.log(
                    "Fullscreen:",
                    error
                );
            }
        };


    return (
        <div
            className="
                fixed
                inset-0
                z-[99999]
                flex
                flex-col
                bg-[#202124]
            "
        >

            <header
                className="
                    h-[62px]
                    flex-none
                    flex
                    items-center
                    gap-3
                    px-4
                    bg-[#17191c]
                    border-b
                    border-white/10
                    text-white
                "
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate(-1)
                    }
                    className="
                        h-9
                        px-3
                        flex
                        items-center
                        gap-2
                        rounded-lg
                        hover:bg-white/10
                    "
                >
                    <ArrowLeftOutlined />

                    <span
                        className="
                            font-semibold
                        "
                    >
                        THƯ VIỆN
                    </span>
                </button>


                <div
                    className="
                        flex-1
                        min-w-0
                    "
                >
                    <div
                        className="
                            truncate
                            font-semibold
                        "
                    >
                        {title ||
                            "Tài liệu"}
                    </div>

                    <div
                        className="
                            text-[11px]
                            text-gray-400
                        "
                    >
                        Đang đọc trực tuyến
                    </div>
                </div>


                <button
                    type="button"
                    onClick={() => {
                        setLoading(
                            true
                        );

                        setError("");

                        setReloadKey(
                            value =>
                                value + 1
                        );
                    }}
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Tải lại"
                >
                    <ReloadOutlined />
                </button>


                <button
                    type="button"
                    onClick={
                        toggleFullscreen
                    }
                    className="
                        w-9
                        h-9
                        rounded-lg
                        hover:bg-white/10
                    "
                    title="Toàn màn hình"
                >
                    {fullscreen
                        ? <CompressOutlined />
                        : <ExpandOutlined />
                    }
                </button>

            </header>


            <main
                className="
                    relative
                    flex-1
                    min-h-0
                    bg-[#202124]
                "
            >

                {loading && (
                    <div
                        className="
                            absolute
                            inset-0
                            z-30
                            flex
                            items-center
                            justify-center
                            bg-[#202124]
                            text-white
                        "
                    >
                        <div
                            className="
                                text-center
                            "
                        >
                            <div
                                className="
                                    mx-auto
                                    w-10
                                    h-10
                                    rounded-full
                                    border-4
                                    border-white/20
                                    border-t-white
                                    animate-spin
                                "
                            />

                            <div
                                className="
                                    mt-4
                                    font-semibold
                                "
                            >
                                Đang tải tài liệu...
                            </div>

                            <div
                                className="
                                    mt-1
                                    text-xs
                                    text-gray-400
                                "
                            >
                                Tài liệu lớn có thể cần thêm vài giây.
                            </div>
                        </div>
                    </div>
                )}


                {error ? (
                    <div
                        className="
                            absolute
                            inset-0
                            flex
                            items-center
                            justify-center
                            p-5
                        "
                    >
                        <div
                            className="
                                max-w-[520px]
                                rounded-2xl
                                bg-white
                                p-6
                                text-gray-800
                            "
                        >
                            <div
                                className="
                                    text-lg
                                    font-semibold
                                "
                            >
                                Không mở được tài liệu
                            </div>

                            <div
                                className="
                                    mt-2
                                    text-sm
                                    text-gray-500
                                "
                            >
                                {error}
                            </div>

                            <button
                                type="button"
                                onClick={() => {
                                    setLoading(true);
                                    setError("");
                                    setReloadKey(
                                        value =>
                                            value + 1
                                    );
                                }}
                                className="
                                    mt-4
                                    rounded-lg
                                    bg-blue-600
                                    px-4
                                    py-2
                                    text-white
                                "
                            >
                                Thử lại
                            </button>
                        </div>
                    </div>
                ) : pdfUrl ? (
                    <>
                        <iframe
                            key={reloadKey}
                            src={pdfUrl}
                            title={
                                title ||
                                "PDF"
                            }
                            onLoad={() => {
                                setLoading(
                                    false
                                );
                            }}
                            onError={() => {
                                setLoading(
                                    false
                                );

                                setError(
                                    "Không tải được tài liệu PDF."
                                );
                            }}
                            className="
                                absolute
                                inset-0
                                w-full
                                h-full
                                border-0
                                bg-[#202124]
                            "
                        />

                        {/*
                          Che Add to Drive / Download /
                          Print / More.
                          Thu hep de khong che qua rong.
                        */}
                        <div
                            className="
                                absolute
                                top-0
                                right-0
                                z-[60]
                                h-[56px]
                                w-[178px]
                                bg-[#3c3c3c]
                            "
                            aria-hidden="true"
                        />
                    </>
                ) : null}

            </main>

        </div>
    );
}
